export const SAVE_WBS_CU_TASK_STATE_ATTR = 'uprice/SAVE_WBS_CU_TASK_STATE_ATTR';
